import EditableFieldDirective from './editable-field.directive';


angular
  .module('Tiller.Components', [])
  .directive('editableField', EditableFieldDirective)

export const moduleName = 'Tiller.Components';

export default {
  moduleName,
}
